import React, { useEffect, useLayoutEffect, useRef } from 'react';
import Popper, { PopperProps } from '@mui/material/Popper';
import { makeStyles } from '@mui/styles';
import Fade from '@mui/material/Fade';
import { useClickOff } from "../hooks/useClickOff";

type PopperContainerProps = PopperProps & {
	onClickOff: Function
}

const useStyles = makeStyles(theme => ({
	paper: {
		// padding: 16,
		// borderRadius: 4,
		// boxShadow: '2px 2px 10px rgb(0 0 0 / 50%)',
		// margin: '14px',
		backgroundColor: '#fff',
		'& .cb-shape-options': {
			margin: -16
		},
		'&::after': {
			content: "''",
			display: "block",
			position: "absolute",
			transform: "rotate(45deg)",
			width: 12,
			height: 12,
			backgroundColor: '#fff',
		},
		'&.right::after': {
			borderBottom: "1px solid rgba(0,0,0,0.1)",
			borderLeft: "1px solid rgba(0,0,0,0.1)",
			left: -7,
			top: "calc(50% - 12px / 2)"
		},
		'&.bottom::after': {
			boxShadow: "0px -1px 0px rgba(0,0,0,0.1)",
			top: -7,
			left: "calc(50% - 38px / 2)"
		}
	},
}));


const PopperContainer = ({ onClickOff = () => { }, ...props }: PopperContainerProps) => {
	const classes = useStyles();
	const paperRef = useRef(null);

	const onScroll = () => {
		onClickOff();
	}

	useLayoutEffect(() => {
		window.addEventListener("scroll", onScroll, true);

		// Remove event listeners on cleanup
		return () => {
			window.removeEventListener("scroll", onScroll, true);
		};
	}, []);

	useClickOff(paperRef, () => onClickOff());
	return (
		<Popper {...props} onPointerDown={e => e.stopPropagation()}
		transition>
			{({ TransitionProps }) => (
				<Fade {...TransitionProps}>
					<div className={`${classes.paper} ${props.placement}`} ref={paperRef}>
						{props.children}
					</div>
				</Fade>
			)}
		</Popper>
	);
}

export default PopperContainer;
